import { Button } from "primereact/button"
import styles from "../../../../styles/kiosk/KioskCustomDataTable.module.css"
import { useState } from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { classNames } from "primereact/utils"

const CustomTable = ({
  headers,
  collection,
  headerTemplate,
  sortField,
  sortOrder,
  onSort,
  expandedRows,
  rowExpansionTemplate,
  dataKey,
  wrapperClassName,
  dataTableClassName,
  showPaginator,
  rowsPerPage = 25,
  rowsPerPageOptions = [5, 10, 25, 50],
}) => {
  const [sortData, setSortData] = useState({
    sortField: undefined,
    sortOrder: undefined,
  })
  const [ascendingData, setAscendingData] = useState(true)

  const onSortData = (newSortField) => {
    let isAscending = !ascendingData

    //If we are changing the sorting field, keep the direction of the sort
    const currentSortField = sortField || sortData.sortField
    if (newSortField !== currentSortField) {
      isAscending = ascendingData
    }

    setAscendingData(isAscending)

    if (onSort) {
      onSort({
        sortField: newSortField,
        sortOrder: isAscending ? 1 : -1,
      })
    } else {
      setSortData({
        sortField: newSortField,
        sortOrder: isAscending ? 1 : -1,
      })
    }
  }

  const Getheader = (header) => {
    if (headerTemplate) {
      return <th>{headerTemplate(header)}</th>
    }

    const currentSortField = sortField || sortData.sortField
    let sortIcon = "pi-sort"

    if (currentSortField === header.value) {
      if (ascendingData) {
        sortIcon = "pi-sort-down"
      } else {
        sortIcon = "pi-sort-up"
      }
    }

    return (
      <div className={styles.headerItem}>
        {header.label}
        {header.label && !header.noSort && (
          <Button
            icon={`pi ${sortIcon}`}
            className={styles.sortButton}
            onClick={() => {
              onSortData(header.value)
            }}
          />
        )}
      </div>
    )
  }

  return (
    <>
      <div className={classNames(styles.tableWrapper, wrapperClassName || "")}>
        <DataTable
          value={collection}
          className={classNames(
            dataTableClassName || "",
            styles.customDataTable
          )}
          expandedRows={expandedRows}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey={dataKey}
          sortField={sortField || sortData.sortField}
          sortOrder={sortOrder || sortData.sortOrder}
          onSort={(event) => {
            onSortData(event.sortField)
          }}
          paginator={showPaginator}
          rows={rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
        >
          {headers?.map((headerConfig) => (
            <Column
              field={headerConfig.value}
              header={Getheader(headerConfig)}
              body={headerConfig.dataTemplate}
              className={headerConfig.className}
              expander={headerConfig.expander}
              sortable={headerConfig.sort}
            />
          ))}
        </DataTable>
      </div>
    </>
  )
}
export default CustomTable
